import { ChevronRight } from "lucide-react";

export function ProcurementQueueOpenIndicator() {
  return (
    <span className="work-list-open-indicator" aria-hidden="true">
      <ChevronRight size={17} />
    </span>
  );
}
